import { ZOption } from "src/types/ZOption";

export const langList: ZOption[] = [
  { value: "ru", label: "RU" },
  { value: "en", label: "EN" },
];
